var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6667 23.9999C26.6667 15.6705 22.4236 8.33222 15.981 4.02856L2.66675 23.9999H8.06676C8.02304 23.7845 8.00008 23.5615 8.00008 23.3332C8.00008 21.4923 9.49247 19.9999 11.3334 19.9999C13.1744 19.9999 14.6667 21.4923 14.6667 23.3332C14.6667 23.5615 14.6438 23.7845 14.6001 23.9999H26.6667ZM9.97141 13.0432L13.6183 7.57283C14.2638 8.18073 14.6667 9.04324 14.6667 9.99988C14.6667 11.8408 13.1744 13.3332 11.3334 13.3332C10.8482 13.3332 10.3872 13.2295 9.97141 13.0432ZM22.4179 20.8367C22.0697 18.6455 21.3655 16.5729 20.3666 14.6799C18.6663 14.8316 17.3334 16.2601 17.3334 17.9999C17.3334 19.8408 18.8258 21.3332 20.6667 21.3332C21.3091 21.3332 21.909 21.1515 22.4179 20.8367Z",
    fill: "url(#paint0_linear_887_4807)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6666 23.9999H26.6666C26.6666 15.6705 22.4234 8.33222 15.9808 4.02856L13.7617 7.35714C19.1306 10.9435 22.6665 17.0588 22.6666 23.9999Z",
    fill: "url(#paint1_linear_887_4807)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6182 7.57275L9.97132 13.0431C10.3872 13.2295 10.8481 13.3331 11.3333 13.3331C13.1743 13.3331 14.6667 11.8407 14.6667 9.9998C14.6667 9.04316 14.2637 8.18065 13.6182 7.57275ZM14.5999 24.0001H8.06673C8.02297 23.7846 8 23.5615 8 23.3331C8 21.4922 9.49238 19.9998 11.3333 19.9998C13.1743 19.9998 14.6667 21.4922 14.6667 23.3331C14.6667 23.5615 14.6437 23.7846 14.5999 24.0001ZM20.3665 14.6798C21.3654 16.5728 22.0696 18.6454 22.4178 20.8366C21.9089 21.1514 21.309 21.3331 20.6667 21.3331C18.8257 21.3331 17.3333 19.8407 17.3333 17.9998C17.3333 16.26 18.6662 14.8315 20.3665 14.6798Z",
    fill: "url(#paint2_linear_887_4807)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 26.6665V23.9998H22.6667C23.0753 23.1827 23.9105 22.6665 24.8241 22.6665H26.6667V26.6665H2.66675Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4807",
    x1: 14.0001,
    y1: 7.33325,
    x2: 14.0001,
    y2: 23.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4807",
    x1: 20.2141,
    y1: 4.02856,
    x2: 20.2141,
    y2: 23.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_887_4807",
    x1: 15.2089,
    y1: 7.57275,
    x2: 15.2089,
    y2: 24.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.58948ead6a9978c35ae291fabe1a2970.svg";
export { ForwardRef as ReactComponent };